import { ORGANIZATION_TYPES_SHORT } from "@/utils/constants";

export const organizationFields = [
  { 
    field: 'name', 
    visible: [ORGANIZATION_TYPES_SHORT.ALL], 
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the organization name.' 
  },
  {
    field: 'address1',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'Please enter the address.'
  },
  {
    field: 'address2',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [],
    validationMessage: 'Please enter address 2.'
  },
  {
    field: 'city',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'Please enter the city.'
  },
  {
    field: 'stateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'Please enter the state.'
  },
  {
    field: 'postalCode',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.TPA],
    validationMessage: 'Please enter the postal code.'
  },
  {
    field: 'phone',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the phone number.'
  },
  {
    field: 'countyId',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE],
    required: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    validationMessage: 'Please select the county.'
  },
  {
    field: 'fax',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Please enter the fax number.'
  },
  {
    field: 'otherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE],
    required: [ORGANIZATION_TYPES_SHORT.FOSC],
    validationMessage: 'Please enter the other county name.'
  },
  {
    field: 'mailAddress1',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please enter the mailing address.'
  },
  {
    field: 'mailAddress2',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: []
  },
  {
    field: 'mailCity',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please enter the mailing city.'
  },
  {
    field: 'mailStateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please enter the mailing state.'
  },
  {
    field: 'mailPostalCode',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.HP, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please enter the mailing postal code.'
  },
  {
    field: 'mailCountyId',
    visible: [ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please select the mailing county.'
  },
  {
    field: 'mailOtherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please enter the other mailing county name.'
  },
  {
    field: 'webUrl',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Please enter the website URL.'
  },
  {
    field: 'fiscalYearEnd',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.HCE, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please select the fiscal year end.'
  },
  {
    field: 'openDate',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    validationMessage: 'Please select the open date.'
  },
  {
    field: 'closeDate',
    visible: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    required: [ORGANIZATION_TYPES_SHORT.URO, ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI],
    validationMessage: 'Please select the close date.'
  },
  {
    field: 'npiNumber',
    visible: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    required: [ORGANIZATION_TYPES_SHORT.FOSC, ORGANIZATION_TYPES_SHORT.DI, ORGANIZATION_TYPES_SHORT.CEX],
    validationMessage: 'Please enter the NPI number.'
  },
  {
    field: 'naicNumber',
    visible: [ORGANIZATION_TYPES_SHORT.HP],
    required: [ORGANIZATION_TYPES_SHORT.HP],
    validationMessage: 'Please enter the NAIC number.'
  },
  {
    field: 'groupCode',
    visible: [ORGANIZATION_TYPES_SHORT.HP],
    required: [],
    validationMessage: 'Please enter the group code.'
  },
  {
    field: 'taxId',
    visible: [ORGANIZATION_TYPES_SHORT.URO],
    required: [],
    validationMessage: 'Please enter the tax ID.'
  }
 
];

export const contactFields = [
  { 
    field: 'firstName', 
    visible: [ORGANIZATION_TYPES_SHORT.ALL], 
    required: [ORGANIZATION_TYPES_SHORT.ALL] 
  },
  {
    field: 'lastName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'address1',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'address2',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'city',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'stateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'postalCode',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'countyId',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'otherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'phone',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'phoneExtension',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'fax',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: []
  },
  {
    field: 'email',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL]
  },
  {
    field: 'title',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.URO]
  }
];

export const registerContactFields = [
  { 
    field: 'contactFirstName', 
    visible: [ORGANIZATION_TYPES_SHORT.ALL], 
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact first name.' 
  },
  {
    field: 'contactLastName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact last name.'
  },
  {
    field: 'contactAddress1',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact address.'
  },
  {
    field: 'contactAddress2',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Please enter the contact address 2.'
  },
  {
    field: 'contactCity',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact city.'
  },
  {
    field: 'contactStateProvince',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact state.'
  },
  {
    field: 'contactPostalCode',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact postal code.'
  },
  {
    field: 'contactCountyId',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Please enter the contact county.'
  },
  {
    field: 'contactOtherCountyName',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Please enter the contact other county name.'
  },
  {
    field: 'contactPhone',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact phone number.'
  },
  {
    field: 'contactPhoneExtension',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Please enter the contact phone extension.'
  },
  {
    field: 'contactFax',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [],
    validationMessage: 'Please enter the contact fax number.'
  },
  {
    field: 'contactEmail',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.ALL],
    validationMessage: 'Please enter the contact email.'
  },
  {
    field: 'contactTitle',
    visible: [ORGANIZATION_TYPES_SHORT.ALL],
    required: [ORGANIZATION_TYPES_SHORT.URO],
    validationMessage: 'Please enter the contact title.'
  }
];
